<div class="row">
    <div class="col-12">
        <div class="card">
            <!-- <div class="card-header">
                <div class="title"> Выгрузить данные</div>
                <div class="tools">
                    <button type="button" class="btn btn-primary btn-sm" (click)="onDownload()" [disabled]="form.invalid">
                        <i class="bi bi-save"></i> {{ 'UPLOAD' | translate }}
                    </button>
                </div>
            </div> -->

            <div class="card-body">

                <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
                    
                    <div class="row type-upload">

                        <div class="col-10 type-upload_input">

                            <div class="form-group">
                                <label class="filter-label"> {{ ' Выберите спецификацию' | translate }}</label>
                                <svg-icon tooltipClass="clue-name" ngbTooltip="Обязательное для заполнения" src="/assets/images/icons/info-circle.svg" [stretch]="true"
                                [svgStyle]="{'width.px':15, 'height.px':15, 'margin-left.px':6}"></svg-icon>
                                <ng-select 
                                class="custom" 
                                clearAllText="{{ 'CLEAR' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="specification_id" 
                                [multiple]="false" 
                                [items]="specifications">
                                </ng-select>
                            </div>
                        </div>

                        <div class="col-2 type-upload_btn">
                            <button type="button" class="btn btn-primary upload-btn  btn-create" (click)="onDownload()" [disabled]="form.invalid"> {{ 'UPLOAD' | translate }}</button>
                        </div>
                    </div>


                    <!-- <div class="row">

                        <div class="col-12">

                            <div class="form-group">
                                <label class="filter-label"> Выберите спецификацию</label>
                                <ng-select 
                                class="custom" 
                                clearAllText="{{ 'CLEAR' | translate }}"
                                notFoundText="{{ 'NO_DATA' | translate }}" 
                                bindLabel="name" 
                                bindValue="id"
                                formControlName="specification_id" 
                                [multiple]="false" 
                                [items]="specifications">
                                </ng-select>
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.type">
                                        <div class="text-error" *ngIf="validation('type', item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>    -->

                </form>    

            </div>
        </div>
    </div>
</div>